import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import ForgotPassword from "@/pages/ForgotPassword";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminProfile from "@/pages/AdminProfile";
import CMS from "@/pages/CMS";
import WhatsappOnboarding from "@/pages/WhatsappOnboarding";
import OnboardingChecklist from "@/pages/OnboardingChecklist";
import AdminOnboarding from "@/pages/AdminOnboarding";
import AdminLeads from "@/pages/AdminLeads";
import AdminNewsletter from "@/pages/AdminNewsletter";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsAndConditions from "@/pages/TermsAndConditions";
import BlogListing from "@/pages/BlogListing";
import BlogDetail from "@/pages/BlogDetail";
import AdminBlog from "@/pages/AdminBlog";
import AdminBlogEditor from "@/pages/AdminBlogEditor";
import AdminBlogCategories from "@/pages/AdminBlogCategories";
import AdminBlogTags from "@/pages/AdminBlogTags";
import AdminBlogAuthors from "@/pages/AdminBlogAuthors";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <div className="app-top-bar" aria-hidden="true" />
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AuthProvider>
            <ThemeProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/whatsapp-onboarding" element={<OnboardingChecklist />} />
              <Route path="/whatsapp-onboarding/apply" element={<WhatsappOnboarding />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/blog" element={<BlogListing />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/forgot-password" element={<ForgotPassword />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/profile" element={<ProtectedRoute><AdminProfile /></ProtectedRoute>} />
              <Route path="/admin/cms" element={<ProtectedRoute><CMS /></ProtectedRoute>} />
              <Route path="/admin/onboarding" element={<ProtectedRoute><AdminOnboarding /></ProtectedRoute>} />
              <Route path="/admin/leads" element={<ProtectedRoute><AdminLeads /></ProtectedRoute>} />
              <Route path="/admin/newsletter" element={<ProtectedRoute><AdminNewsletter /></ProtectedRoute>} />
              <Route path="/admin/blog" element={<ProtectedRoute><AdminBlog /></ProtectedRoute>} />
              <Route path="/admin/blog/categories" element={<ProtectedRoute><AdminBlogCategories /></ProtectedRoute>} />
              <Route path="/admin/blog/tags" element={<ProtectedRoute><AdminBlogTags /></ProtectedRoute>} />
              <Route path="/admin/blog/authors" element={<ProtectedRoute><AdminBlogAuthors /></ProtectedRoute>} />
              <Route path="/admin/blog/:id/edit" element={<ProtectedRoute><AdminBlogEditor /></ProtectedRoute>} />
            </Routes>
            </ThemeProvider>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;